export default "<app-update-notification></app-update-notification>\r\n<router-outlet></router-outlet>";